module.exports = new __parcel__URL__("bossfight_back_button.3258106d.png").toString();